import { Filtros } from "../../Domain/EntityParams";

export const FiltroPrecioEspecialidad: Filtros = {
    Filtros: [
        {
            $match: {
                'Estado.ID_Estado': 1
            }
        },
        {
            $project: {
                IsDebug: 0,
                Bitacora: 0,
                Estado: 0,
            }
        }
    ]
}